import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { DisplayFormat } from '../utils/displayFormat';

interface DisplayFormatContextType {
  displayFormat: DisplayFormat;
  setDisplayFormat: (format: DisplayFormat) => void;
}

const DisplayFormatContext = createContext<DisplayFormatContextType | undefined>(undefined);

export const DisplayFormatProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [displayFormat, setDisplayFormat] = useState<DisplayFormat>('currency');

  const value = {
    displayFormat,
    setDisplayFormat
  };

  return (
    <DisplayFormatContext.Provider value={value}>
      {children}
    </DisplayFormatContext.Provider>
  );
};

export const useDisplayFormat = () => {
  const context = useContext(DisplayFormatContext);
  if (context === undefined) {
    throw new Error('useDisplayFormat must be used within a DisplayFormatProvider');
  }
  return context;
};

export default DisplayFormatContext;




